import { Directive, ElementRef, HostBinding } from '@angular/core';

@Directive({
  selector: '[tabLabelWrapper]'
})
export class TabLabelWrapperDirective {
  @HostBinding('class')
  classBinding = 'label-wrapper';

  constructor(
    public elementRef: ElementRef
  ) { }

  focus(): void {
    this.elementRef.nativeElement.focus();
  }

  getOffsetLeft(): number {
    return this.elementRef.nativeElement.offsetLeft;
  }

  getOffsetWidth(): number {
    return this.elementRef.nativeElement.offsetWidth;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/achoo-tabs/tab-label-wrapper.directive.ts